<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3300_55)">
      <path
        d="M18.3334 9.23333V10C18.3323 11.797 17.7504 13.5456 16.6745 14.9849C15.5985 16.4241 14.0861 17.4771 12.3628 17.9866C10.6395 18.4961 8.79774 18.4349 7.11208 17.8122C5.42642 17.1894 3.98723 16.0384 3.00915 14.5309C2.03108 13.0234 1.56651 11.2401 1.68475 9.44693C1.80299 7.6538 2.49769 5.94694 3.66525 4.58089C4.83281 3.21485 6.41068 2.26282 8.16351 1.86679C9.91635 1.47076 11.7502 1.65195 13.3917 2.38333M18.3334 3.33333L10 11.675L7.50003 9.175"
        stroke="#039855"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3300_55">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: '20',
    },
    width: {
      type: String,
      default: '20',
    },
    color: {
      type: String,
      default: 'primary-purple-600',
    },
  },
  computed: {
    /**
     * Icon Style
     * @param {void}
     * @returns {string} - Color
     * @description Assigns the specific color to the icon
     */
    iconStroke() {
      return `var(--${this.color})`
    },
  },
}
</script>
